import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const DeleteRowDialog = ({ deleteConfirm, setDeleteConfirm, removeRow }) => (
  <Dialog open={!!deleteConfirm} onOpenChange={(open) => { if (!open) setDeleteConfirm(null); }}>
    <DialogContent className="max-w-xs z-50">
      <DialogHeader>
        <DialogTitle>Remove Row?</DialogTitle>
        <DialogDescription>
          Are you sure you want to remove row {deleteConfirm ? deleteConfirm.idx + 1 : ''}? Design: {deleteConfirm?.designCode}
        </DialogDescription>
      </DialogHeader>
      <div className="flex gap-2 justify-end pt-2">
        <Button variant="outline" size="sm" onClick={() => setDeleteConfirm(null)} data-testid="so-delete-cancel">Cancel</Button>
        <Button variant="destructive" size="sm" onClick={() => { removeRow(deleteConfirm.idx); setDeleteConfirm(null); }} data-testid="so-delete-confirm">Remove</Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default DeleteRowDialog;
